import React from 'react'
import './Header.css'

const Header = () => {
  return (
    <div className='header'>

<div className="header-contents">
<h2>Authentic taste & rich aroma</h2>
<p>Indulge in the rich, aromatic flavors and potent effects that only the finest quality khat can provide. Expertly sourced from our lush farms, and delivered discretely to your doorstep.</p>

<button>View Menu</button>


</div>


    </div>
  )
}

export default Header